<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="bar">
        <div class="d-flex align-center">
          <i class="far fa-comment fa-flip-horizontal" style="font-size: 25px;" />
          <h2 class="pl-3">
            {{ $t('brandname') }}
          </h2>
        </div>
        <div class="language-btn">
          <LanguageSelector />
        </div>
      </div>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        size="64"
        width="7"
        color="blue"
      />
    </v-overlay>
    <notifications position="bottom center" :ignore-duplicates="true" />
  </v-app>
</template>

<script>
import LanguageSelector from '@/components/system/LanguageSelector.vue';

export default {
  name: 'App',
  components: {
    LanguageSelector,
  },
  data: () => ({
    //
  }),
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },
  mounted() {
    const { token } = this.$route.query;
    if (token) {
      this.$cookies.set('token', token);
    } else if (process.env.NODE_ENV === 'development') {
      if (process.env.VUE_APP_TOKEN && process.env.VUE_APP_TOKEN !== 'QSTICKER_TOKEN_HERE') {
        this.$cookies.set('token', process.env.VUE_APP_TOKEN);
      }
    }
  },
};
</script>

<style lang="scss">
.loading-dialog {
  background-color: rgba(0, 0, 0, 0.2)
}
.bar{
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
